import { render, staticRenderFns } from "./modalBase.vue?vue&type=template&id=52f73765&"
import script from "./modalBase.vue?vue&type=script&lang=js&"
export * from "./modalBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports